const html = require("./html/reviewServiceRowView.html");
import {setElementsFromScope, insertValAndManageFocus, show, hide, enableInput, disableInput, handleDisplayFor} from "../../../utilities/selectorHelpers";
import _ from "underscore";
import $ from "jquery";
import AsnDetailStore from "../../../stores/AsnDetailStore";
import ServiceStore from "../../../stores/CmrServiceStore";
import DomainStore from "../../../stores/CmrDomainStore";
import {toCurrency} from "../../../utilities/currency";
import {isBlank,isPresent} from "../../../utilities/general";

const noop = ()=>{};

const elementsMap = {
  reviewTabView: ".review-tab-service-inner",
  reviewSkuName: ".review-sku-name",
  reviewServiceName: ".review-service-name",
  reviewQuantity: ".review-quantity",
  reviewEstimatedCost: ".review-estimated-cost"
};

export default function ReviewView(services, asnDetail,
  {
    asnDetails=[]
  }={}
  ){
  const self = this;
  self._element = $();
  const els = {};

  self.init = function(){
    render();
  };

  function render(){
    self._element = $(html);
    setElements();
    setWidgets();
    bindElements();
    bindStores();
    update();
  }

  function bindElements(){
  }

  function bindStores(){
  }

  self.unbindListeners = function(){
  };

  function setWidgets(){
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, self._element);
  }

  self.getElement = function(){
    return self._element;
  }

  function update(){
    updateReviewText();
  }

  function updateReviewText(){
    //Shipment Level
    if(isBlank(asnDetail)){
      updateShipmentLevelReviewText();
    }
    //Product Level
    if(isPresent(asnDetail)){
      updateProductLevelReviewText();
    }
  }

  function updateShipmentLevelReviewText(){
    if(services.length){
      els.reviewSkuName.html(`All Units in Shipment`);
      els.reviewQuantity.html(`All Units`);
      els.reviewServiceName.html('');
      els.reviewEstimatedCost.html('');

      _(services).map((service, rowIdx)=>{
        const domain = getDomain(service.id);
        if(DomainStore.currencyToHtml(domain) == 'FREE'){
          els.reviewServiceName.append(`${DomainStore.getTitle(domain)} (FREE)<br>`);
          els.reviewEstimatedCost.append(`FREE<br>`);
        }else{
          els.reviewServiceName.append(`${DomainStore.getTitle(domain)} (${DomainStore.currencyToHtml(domain)})<br>`);
          els.reviewEstimatedCost.append(toCurrency(DomainStore.getValue(domain)) + `<br>`);
        }
      });
    }
  }

  function updateProductLevelReviewText(){
    if(services.length){
      els.reviewSkuName.html(asnDetail.sku);
      els.reviewQuantity.html(AsnDetailStore.calcTotalQuantityFor(asnDetail));
      els.reviewServiceName.html('');
      els.reviewEstimatedCost.html('');
      _(services).map((service, rowIdx)=>{
        const domain = getDomain(service.id);
        if(DomainStore.currencyToHtml(domain) == 'FREE'){
          els.reviewServiceName.append(`${DomainStore.getTitle(domain)} (FREE)<br>`);
          els.reviewEstimatedCost.append(`FREE<br>`);
        }else{
          els.reviewServiceName.append(`${DomainStore.getTitle(domain)} (${DomainStore.currencyToHtml(domain)}/unit)<br>`);
          els.reviewEstimatedCost.append(toCurrency(getAggregateCurrencyTotalViaCurrencyPerUnits(DomainStore.getValue(domain))) + `<br>`);
        }
      });
    }
  }

  function getAggregateCurrencyTotalViaCurrencyPerUnits(numb){
    return calcProductsQuantity() * numb;
  }

  function calcProductsQuantity(){
    return AsnDetailStore.calcTotalQuantityFor(asnDetail);
  }

  function getService(serviceId){
    return ServiceStore.getData()[serviceId];
  }

  function getDomain(serviceId){
    return DomainStore.getData()[getService(serviceId).cdm_id];
  }
}



// WEBPACK FOOTER //
// ./src/pages/asns/ServicesTab/ReviewDetailRowView.js